import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./style.scss";
import Select from "react-select";
import crossIcon from "../../assets/icons/cross_icon_white.svg";
import customStyles from "../../customStyles";
import { addAddress, editAddress } from "../../utils/apis/address";
import { useDispatch, useSelector } from "react-redux";
import { country } from "../../utils/constants/country";
import { returnErrors } from "../../utils/store/reducers/Error";
import { returnMessages } from "../../utils/store/reducers/Message";

const nameRegex = /^[A-Za-z\s'-]+$/;
// Validation schema
const validationSchema = Yup.object({
  first_name: Yup.string()
    .required("First Name is required")
    .min(2, "First Name must be at least 2 characters long")
    .matches(
      nameRegex,
      "First Name can only contain letters, spaces, hyphens, or apostrophes"
    ),

  last_name: Yup.string()
    .required("Last Name is required")
    .min(2, "Last Name must be at least 2 characters long")
    .matches(
      nameRegex,
      "Last Name can only contain letters, spaces, hyphens, or apostrophes"
    ),
  number: Yup.string()
    .typeError("Phone number must be a number")
    .max(15, "Contact Number must be less than 15 digits")
    .min(5, "Phone number must be at least 5 digits long")
    .required("Contact Number is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  // apartment_no: Yup.string(),
  city: Yup.string().required("City is required"),
  street_address: Yup.string().required("Street Address is required"),
  state: Yup.string().required("State is required"),
  country: Yup.string().required("Country is required"),
  zip_code: Yup.string().required("Zip Code is required"),
  apartment_no: Yup.string().required("Apartment No is required"),
});

const AddressModal = ({
  setIsVisible,
  isVisible,
  setIsEditVisible,
  isEditVisible,
  toEditAddress,
}) => {
  const initialValues = isEditVisible
    ? toEditAddress
    : {
        first_name: "",
        last_name: "",
        number: "",
        email: "",
        apartment_no: "",
        city: "",
        street_address: "",
        state: "",
        country: "",
        zip_code: "",
      };
  const { idToken, customLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const handleSubmit = async (values, { setSubmitting }) => {
    if (isEditVisible) {
      try {
        await editAddress(values, idToken, dispatch);
      } catch (error) {
        console.error(error);
      }
      setIsEditVisible(!isEditVisible);
    } else {
      try {
        await addAddress(values, idToken, dispatch);
      } catch (error) {
        console.error("Error", error);
      }
      setIsVisible(!isVisible);
    }
    setSubmitting(false);
  };

  const countryOptions = country?.map((item) => ({
    label: item?.country,
    value: item?.country,
  }));

  return (
    <div
      className="address_modal_container edit_address_modal"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="add_address_wrapper">
        <div className="header_container">
          <div className="header_wrapper">
            <h2>{isEditVisible ? "Edit Address" : "Add Address"}</h2>
            <p>
              {isEditVisible
                ? "Edit your billing address"
                : "Add a new address"}
            </p>
          </div>
          <img
            src={crossIcon}
            alt="Close"
            onClick={() => {
              if (isVisible) {
                setIsVisible(!isVisible);
              } else {
                setIsEditVisible(!isEditVisible);
              }
            }}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, values, isSubmitting }) => (
            <Form className="addAddress_form">
              <div className="top_section">
                <label htmlFor="first_name" className="addAddress_form_input">
                  <span className="form_input_label">First Name</span>
                  <Field
                    type="text"
                    className="form_input_box"
                    id="first_name"
                    name="first_name"
                    placeholder="First Name"
                  />
                  <ErrorMessage
                    name="first_name"
                    component="div"
                    className="error_message"
                  />
                </label>
                <label htmlFor="last_name" className="addAddress_form_input">
                  <span className="form_input_label">Last Name</span>
                  <Field
                    type="text"
                    className="form_input_box"
                    id="last_name"
                    name="last_name"
                    placeholder="Last Name"
                  />
                  <ErrorMessage
                    name="last_name"
                    component="div"
                    className="error_message"
                  />
                </label>
                <label htmlFor="number" className="addAddress_form_input">
                  <span className="form_input_label">Contact Number</span>
                  <Field
                    type="number"
                    className="form_input_box"
                    id="number"
                    name="number"
                    placeholder="Phone Number"
                  />
                  <ErrorMessage
                    name="number"
                    component="div"
                    className="error_message"
                  />
                </label>
              </div>
              <div className="top_section">
                <label htmlFor="email" className="addAddress_form_input">
                  <span className="form_input_label">Email</span>
                  <Field
                    type="email"
                    className="form_input_box"
                    id="email"
                    name="email"
                    placeholder="Email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error_message"
                  />
                </label>
              </div>
              <div className="bottom_section_addr">
                <label htmlFor="apartment_no" className="addAddress_form_input">
                  <span className="form_input_label">Apartment No.</span>
                  <Field
                    type="text"
                    className="form_input_box"
                    id="apartment_no"
                    name="apartment_no"
                    placeholder="Apartment No."
                  />
                  <ErrorMessage
                    name="apartment_no"
                    component="div"
                    className="error_message"
                  />
                </label>
                <label htmlFor="city" className="addAddress_form_input">
                  <span className="form_input_label">City</span>
                  <Field
                    type="text"
                    className="form_input_box"
                    id="city"
                    name="city"
                    placeholder="City"
                  />
                  <ErrorMessage
                    name="city"
                    component="div"
                    className="error_message"
                  />
                </label>
                <label
                  htmlFor="street_address"
                  className="addAddress_form_input"
                >
                  <span className="form_input_label">Street Address</span>
                  <Field
                    type="text"
                    className="form_input_box"
                    id="street_address"
                    name="street_address"
                    placeholder="Street Address"
                  />
                  <ErrorMessage
                    name="street_address"
                    component="div"
                    className="error_message"
                  />
                </label>
                <label htmlFor="state" className="addAddress_form_input">
                  <span className="form_input_label">State</span>
                  <Field
                    type="text"
                    className="form_input_box"
                    id="state"
                    name="state"
                    placeholder="State"
                  />
                  <ErrorMessage
                    name="state"
                    component="div"
                    className="error_message"
                  />
                </label>
                <label htmlFor="login_id" className="form_input_label">
                  <span className="form_input_label">Country</span>
                  <Select
                    className="form_input_box react-select-container customHeight"
                    classNamePrefix="react-select"
                    name="country"
                    placeholder="Select country"
                    styles={customStyles}
                    id="country"
                    isSearchable={true}
                    value={{ label: values.country, value: values.country }}
                    onChange={(option) =>
                      setFieldValue("country", option.value)
                    }
                    options={countryOptions}
                  />
                </label>
                <label htmlFor="zip_code" className="addAddress_form_input">
                  <span className="form_input_label">Zip Code</span>
                  <Field
                    type="text"
                    className="form_input_box"
                    id="zip_code"
                    name="zip_code"
                    placeholder="Zip Code"
                  />
                  <ErrorMessage
                    name="zip_code"
                    component="div"
                    className="error_message"
                  />
                </label>
              </div>
              <div className="button_wrapper">
                <button
                  className="standard-button"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Submit
                </button>
                <button
                  className="cancel_button"
                  type="button"
                  onClick={() => {
                    if (isVisible) {
                      setIsVisible(!isVisible);
                    } else {
                      setIsEditVisible(!isEditVisible);
                    }
                  }}
                >
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddressModal;
